import {
  getNextSetupStep,
  getPreviousSetupStep,
  getSetupStepIndex,
  isSetupStepId,
} from "@/features/admin/course-setup/setupSteps";

/** The steps mirror a course's, worded for paths. Path settings joins them before Check and publish. */
export const LEARNING_PATH_SETUP_STEPS = [
  { id: "about", title: "About the path" },
  { id: "audience", title: "Who it's for" },
  { id: "picture", title: "Path picture" },
  { id: "courses", title: "Courses" },
  { id: "settings", title: "Path settings" },
  { id: "review", title: "Check and publish" },
] as const;

export type LearningPathSetupStepId = (typeof LEARNING_PATH_SETUP_STEPS)[number]["id"];

export const LEARNING_PATH_SETUP_STEP_COUNT = LEARNING_PATH_SETUP_STEPS.length;

/** The step a saved path opens on when the URL has no step. */
export const DEFAULT_LEARNING_PATH_SETUP_STEP: LearningPathSetupStepId = "about";

export const isLearningPathSetupStepId = (value: unknown): value is LearningPathSetupStepId =>
  isSetupStepId(LEARNING_PATH_SETUP_STEPS, value);

export const getLearningPathSetupStepNumber = (stepId: LearningPathSetupStepId): number =>
  getSetupStepIndex(LEARNING_PATH_SETUP_STEPS, stepId) + 1;

export const getNextLearningPathSetupStep = (
  stepId: LearningPathSetupStepId,
): LearningPathSetupStepId | null => getNextSetupStep(LEARNING_PATH_SETUP_STEPS, stepId);

export const getPreviousLearningPathSetupStep = (
  stepId: LearningPathSetupStepId,
): LearningPathSetupStepId | null => getPreviousSetupStep(LEARNING_PATH_SETUP_STEPS, stepId);
